import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { Asset as AssetComponent } from 'b2b-components/theme/components/CMS/Asset';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import fallbackImg from './assets/file-fallback.jpg';
import { ComponentType, Props } from '.';
import './Asset.scss';

const Asset: ComponentType = ({
  className,
  fileName,
  onDownloadButtonClick,
  url,
  thumbnail,
}: Props): ReactElement => {
  const t = useTranslate();
  if (!fileName || !url || !thumbnail) {
    return null;
  }

  const text = {
    download: t('Download'),
  };

  const isImageAsset = url && /\.(jpe?g|png|webp|gif)$/.test(url.toLowerCase());

  const rootClassName = classNames(
    className,
    {
      'cds-cms-Asset--FallbackImg': !isImageAsset,
    },
  );

  return (
    <AssetComponent
      className={rootClassName}
      fileName={fileName}
      onClick={onDownloadButtonClick}
      text={text}
      thumbnail={isImageAsset ? thumbnail : fallbackImg}
      url={url}
    />
  );
};

export {
  Asset,
};
